<div class="status-container">
    <span [ngClass]="status?.toLowerCase()" class="indicator"></span>
    <span *ngIf="status" class="status">{{ statusMapping[status] }}</span>
</div>
